module.exports = __webpack_public_path__ + "newsTitle.b951da00.jpg";